import logdna from '@logdna/browser'

const init = (pinia = {}) => {
  if (!pinia.state.value.__browserLogger) {
    return
  }

  const { __browserLogger: { url, apikey }, __version: version, __env: env } = pinia.state.value

  if (!url || !apikey) {
    console.error('Logdna browser logger was unable to initialize.  Missing url or apikey')
    return
  }

  let user = {}
  let account = {}
  if (pinia.state.value?.__user && pinia.state.value?.__account) {
    user = {
      id: pinia.state.value.__user.email
    }
    account = {
      id: pinia.state.value.__account.id,
      name: pinia.state.value.__account.name,
      planLevel: pinia.state.value.__account.plan,
      pipelinePlanLevel: pinia.state.value.__account.pipelinePlan,
      creationDate: pinia.state.value.__account.created
    }
  }

  const FullstorySessionPlugin = () => ({
    name: 'FullstorySessionPlugin',
    hooks: {
      beforeSend: ({ level, message, lineContext = {} }) => {
        if (window?.FS?.getCurrentSessionURL && level === 'error') {
          lineContext.fullstory = {
            session: window.FS.getCurrentSessionURL(),
            sessionAtLog: window.FS.getCurrentSessionURL(true)
          }
        }
        return {
          level,
          message,
          lineContext
        }
      }
    }
  })

  logdna.init(apikey, {
    url,
    app: 'logdna-web',
    sampleRate: 100,
    disabled: env === 'dev',
    debug: false,
    console: {
      enable: true,
      integrations: ['log', 'debug', 'error']
    },
    plugins: [logdna.plugins.Metrics(), FullstorySessionPlugin()]
  })
  logdna.addContext({
    version,
    env,
    user,
    account
  })
}

export default {
  init,
  logdna
}
